const validateIfCondition = (
    condition: boolean,
    validator: (value: unknown) => string | undefined,
) => (value: unknown) => (condition ? validator(value) : undefined);

export default validateIfCondition;
